module.exports = __webpack_public_path__ + "img/qygl3.50fa1d46.jpg";